// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WH7c7"};